
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs,
              ...rest,
            },
            children.concat([_c('path',{staticClass:"ql-fill",attrs:{"d":"M15.5 15h-1.639a3.858 3.858 0 001.914-2.975 1.8 1.8 0 00-1.6-1.751 1.921 1.921 0 00-2.154 1.426.5.5 0 10.957.291.914.914 0 011.053-.725.81.81 0 01.744.762c0 1.076-1.17 1.87-1.94 2.43A1.456 1.456 0 0012 15.5a.5.5 0 00.5.5h3a.5.5 0 000-1zM9.65 5.241a1 1 0 00-1.409.108L6 7.964 3.759 5.349a1 1 0 00-1.567 1.243q.023.03.049.057L4.684 9.5l-2.443 2.85a1 1 0 001.469 1.357q.026-.027.049-.057L6 11.036l2.241 2.614a1 1 0 101.567-1.243q-.023-.03-.049-.057L7.316 9.5l2.443-2.849a1 1 0 00-.109-1.41z"}})])
          )
        }
      }
    